import React from 'react';
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
	Button,
} from '@chakra-ui/core';

const ResetDialog = ({isOpen, onConfirm, onClose}) => {
	const cancelRef = React.useRef();

	return (
		<AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
			<AlertDialogOverlay />
			<AlertDialogContent>
				<AlertDialogHeader fontSize="lg" fontWeight="bold">
					Reset form
				</AlertDialogHeader>
				<AlertDialogBody>Are you sure you want to reset the form?</AlertDialogBody>
				<AlertDialogFooter>
					<Button ref={cancelRef} onClick={onClose}>
						Cancel
					</Button>
					<Button variantColor="red" onClick={onConfirm} ml={3}>
						Reset
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};

export default ResetDialog;
